<template>
  <div class="emh-side-filters-dealer-contact-info">
    <div
      v-for="line in contactInfoLines"
      :key="line.key"
      class="emh-side-filters-dealer-contact-info__line-container"
      :data-test-id="`emh-side-filters-dealer-contact-info__line-container-${line.key}`"
    >
      <p
        class="emh-side-filters-dealer-contact-info__line-label wb-type-hint"
        :data-test-id="`emh-side-filters-dealer-contact-info__line-label-${line.key}`"
      >
        {{ $t(line.label) }}
      </p>
      <p
        class="emh-side-filters-dealer-contact-info__line-value wb-type-label"
        :data-test-id="`emh-side-filters-dealer-contact-info__line-value-${line.key}`"
      >
        {{ line.value }}
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'EmhSideFiltersDealerContactInfo',
});
</script>

<script lang="ts" setup>
import { DealerInfo } from '@dh-io-emh/shared/src/models/dealer.model';
import { computed, PropType, toRefs } from 'vue';

type DealerContactInfoLine = {
  label: string;
  key: string;
  value: string;
};

const props = defineProps({
  dealerInfo: {
    type: Object as PropType<DealerInfo>,
    required: true,
  },
});

const { dealerInfo } = toRefs(props);

const contactInfoLines = computed<DealerContactInfoLine[]>(() => [
  {
    label: 'dcp.sideFilters.locationsCategory.dealerFilter.addressLabel',
    key: 'address',
    value: dealerInfo?.value.address,
  },
]);
</script>

<style lang="scss" scoped>
.emh-side-filters-dealer-contact-info {
  &__line-container:not(:last-child) {
    @include wb-spacing('margin-bottom', 'xs');
  }

  &__line-label {
    color: var(--wb-grey-45);
  }

  &__line-value {
    color: var(--wb-grey-20);
  }
}
</style>
